import { AxiosResponse } from 'axios';
import BaseService from "@/services/BaseService";
import ServiceResponseEntities from './response-models/ServiceResponseEntities';
import { Requisito } from '@/models/RequisitoBeneficio';

export default class CesantiaService extends BaseService<any> {
    public constructor() {
        super("Cesantia");
    }

    public async documentosRequeridos(step: string): 
    Promise<AxiosResponse<ServiceResponseEntities<Requisito[]>>> {
        return this.get('DocumentosRequeridos/'+ step);
    }
}